import React from 'react';
import { hot } from 'react-hot-loader';
import { purifier } from '../../../utils/dom';
import s from './Paragraph.scss';

const Paragraph = ({ content, attrs = {}, isPuffContent = false, isAccordianContent = false, inlineCategoryContent = false }) => {
	if (!content) return null;
	const styles = {};
	const classes = [s.paragraph];
	if (attrs.align) styles.textAlign = attrs.align;
	if (attrs.textColor) styles.color = attrs.textColor;
	if (isAccordianContent) classes.push(s.paragraph__accordian);
	if (isPuffContent) classes.push(s.paragraph__puff);
	if (inlineCategoryContent) classes.push(s.paragraph__inlineCategoryContent);

	return (
		<p className={classes.join(' ')} dangerouslySetInnerHTML={{ __html: purifier(content.rawText, { ADD_ATTR: ['target'] }) }} style={styles} />
	);
};

export default hot(module)(Paragraph);
